/**
 * Universal search P1 — callsigns (shorthand on companies, productions, sites
 * and models). Mirrors api/lib/callsigns.js so the form preview shows exactly
 * what the server will store: uppercase A-Z0-9, separators and accents
 * removed, at most MAX_CALLSIGNS of at most MAX_CALLSIGN_LENGTH characters.
 */

export const MAX_CALLSIGNS = 10;
export const MAX_CALLSIGN_LENGTH = 16;

export function foldCallsign(raw: string): string {
  return raw
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

/** "nbcu, S-D m3" → ["NBCU", "SDM3"]: split on commas, fold, drop blanks and repeats. */
export function parseCallsigns(text: string): string[] {
  const out: string[] = [];
  for (const part of text.split(',')) {
    const folded = foldCallsign(part);
    if (folded && !out.includes(folded)) out.push(folded);
  }
  return out;
}

export function formatCallsigns(callsigns: readonly string[] | null | undefined): string {
  return (callsigns ?? []).join(', ');
}

/** A problem to show before saving, or null. */
export function callsignProblem(callsigns: readonly string[]): string | null {
  const long = callsigns.find((c) => c.length > MAX_CALLSIGN_LENGTH);
  if (long) return `${long} is too long — at most ${MAX_CALLSIGN_LENGTH} letters and digits`;
  if (callsigns.length > MAX_CALLSIGNS) return `At most ${MAX_CALLSIGNS} callsigns`;
  return null;
}
